import { useTranslation } from 'react-i18next';
import { api } from '../../api';
import { RecordFilter } from '../../components/RecordFilter';
import { useAccess } from '../../lib/access';
import { FilterChip, useRecordName } from '../accounts/shared';

export function CustomerListFilter({ value, name, onChange }: { value: string; name?: string; onChange: (id: string) => void }) {
  const { t } = useTranslation('commerce');
  const { t: to } = useTranslation('operator');
  const selectedLabel = useRecordName('customer', value, name);
  const access = useAccess();
  if (access.client || !access.has(['customer.manage'])) {
    return value ? <FilterChip label={t('filter.customer', { name: selectedLabel })} onClear={() => onChange('')} /> : null;
  }
  return <RecordFilter label={t('common.customer')} placeholder={to('register.customerSearch')} value={value} selectedLabel={selectedLabel}
    search={async (query, signal) => (await api.listCustomers({ q: query, limit: 20 }, { signal })).items.map((c) => {
      const contact: { email?: string; email_hint?: string } = c;
      return { id: c.id, label: c.display_name, detail: contact.email ?? contact.email_hint };
    })}
    onPick={(item) => onChange(item?.id ?? '')} />;
}
